export default "__VITE_ASSET__DxuWjTn9__"